import { connect } from 'react-redux'
import Header from './Header'
import { toggleMenu } from 'features/Layout/Layout.actions'

const stateToProps = ({ layout, auth: { allConfirmed }, scroll: { atTop } }) => ({
  layout,
  allConfirmed,
  atTop,
})

const dispatchToProps = {
  toggleMenu,
}

export default connect(stateToProps, dispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header.container.js